import StorageService from "../services/general/storage";
import WorkorderItemService from "../services/workorderitems";
import axios from 'axios';
import moment from 'moment';
let vismaAPI = 'https://aral.vedebo.net/visma';
if (window.location.href.indexOf('localhost') >= 0) {
//    vismaAPI = 'http://localhost:44300/visma';
}
const Visma = {
    setAuthToken: (token) => {
        StorageService.setString('vismaAuthToken', token)
    },
    getAuthToken: () => {
        return StorageService.getString('vismaAuthToken');
    },
    getProjects: (projectid) => {
        return new Promise((resolve, reject) => {
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            axios.get(vismaAPI + '/projects' + (projectid ? '/' + projectid : ''), { headers: prepHeaders })
                .then(res => {
                    resolve(res.data);
                }, err => {
                    console.log('err', err);
                    reject(err);
                })
        });
    },
    createProjectInVisma: (project) => {
        return new Promise((resolve, reject) => {
            console.log('creating project', project);
            let newVismaProject = {};

            newVismaProject.Number = project.projectnumber;
            newVismaProject.Name = project.name.substring(0,48);
            newVismaProject.StartDate = moment(project.created).format('YYYY-MM-DD')
            //newVismaProject.CustomerId
            newVismaProject.Notes = project.description;
            newVismaProject.Status = 1;
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            let data = { item: newVismaProject }
            axios.put(vismaAPI + '/projects', data, { headers: prepHeaders })
                .then(res => {
                    resolve(res.data);
                }, err => {
                    console.log('err', err);
                    reject(err);
                })

        });
    },
    getCustomers: (customerid) => {
        return new Promise((resolve, reject) => {
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            axios.get(vismaAPI + '/customers' + (customerid ? '/' + customerid : ''), { headers: prepHeaders })
                .then(res => {
                    resolve(res.data);
                }, err => {
                    console.log('err', err);
                    reject(err);
                })
        });
    },
    getArticles: () => {
        return new Promise((resolve, reject) => {
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            axios.get(vismaAPI + '/articles', { headers: prepHeaders })
                .then(res => {
                    resolve(res.data);
                }, err => {
                    console.log('err', err);
                    reject(err);
                })
        });
    },
    getTermsOfPayment: () => {
        return new Promise((resolve, reject) => {
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            axios.get(vismaAPI + '/termsofpayment', { headers: prepHeaders })
                .then(res => {
                    resolve(res.data);
                }, err => {
                    console.log('err', err);
                    reject(err);
                })
        });
    },
    createCustomerInVisma: (client) => {
        return new Promise((resolve, reject) => {
            Visma.getTermsOfPayment().then((result) => {
                let terms = result.Data.find((item) => { return item.TermsOfPaymentTypeId === 0 && item.NumberOfDays === 30 })
                let newVismaClient = {};
                newVismaClient.CustomerNumber = client.clientnumber;
                newVismaClient.Name = client.name;
                newVismaClient.ContactPersonName = client.contactperson;
                newVismaClient.EmailAddress = client.email;
                newVismaClient.MobilePhone = client.mobile;
                newVismaClient.Telephone = client.phone;
                newVismaClient.InvoiceAddress1 = client.address;
                newVismaClient.InvoicePostalCode = client.pobox;
                newVismaClient.InvoiceCity = client.town;
                newVismaClient.IsPrivatePerson = false;
                newVismaClient.IsActive = true;
                newVismaClient.TermsOfPaymentId = terms.Id;
                let token = Visma.getAuthToken();
                let prepHeaders = {};
                prepHeaders['token'] = token;
                prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
                prepHeaders['Accept'] = 'application/json; charset=utf-8';
                let data = { item: newVismaClient }
                axios.put(vismaAPI + '/customers', data, { headers: prepHeaders })
                    .then(res => {
                        resolve(res.data);
                    }, err => {
                        console.log('err', err);
                        reject(err);
                    })

            }, (err) => {
                reject(err);
            })


        });
    },
    getInvoices: () => {
        return new Promise((resolve, reject) => {
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            axios.get(vismaAPI + '/customerinvoices', { headers: prepHeaders })
                .then(res => {
                    resolve(res.data);
                }, err => {
                    console.log('err', err);
                    reject(err);
                })
        });
    },
    createInvoice: (orderItems, settings, clientID, projectID, articles, remarks, material, materialCost) => {

        return new Promise((resolve, reject) => {
            let token = Visma.getAuthToken();
            let prepHeaders = {};
            prepHeaders['token'] = token;
            prepHeaders['Content-Type'] = 'application/json; charset=utf-8';
            prepHeaders['Accept'] = 'application/json; charset=utf-8';
            let invoice = {};

            invoice.CreatedUtc = new Date().toUTCString();
            invoice.CustomerId = clientID
            invoice.RotReducedInvoicingType = 0
            invoice.EuThirdParty = false


            /*
            invoice.CustomerIsPrivatePerson= false
            invoice.CustomerNumber= "11"
            invoice.DeliveryAddress1= null
            invoice.DeliveryAddress2= null
            invoice.DeliveryCity= null
            invoice.DeliveryCountryCode= null
            invoice.DeliveryCustomerName= null
            invoice.DeliveryDate= "2019-03-14T00=00=00Z"
            invoice.DeliveryMethodCode= null
            invoice.DeliveryMethodName= null
            invoice.DeliveryPostalCode= null
            invoice.DeliveryTermCode= null
            invoice.DeliveryTermName= null
           
            invoice.HouseWorkOtherCosts= null
            invoice.IncludesVat= false
            invoice.InvoiceAddress1= "Westerweg 17a"
            invoice.InvoiceAddress2= ""
            invoice.InvoiceCity= "Oosterwolde"
            invoice.InvoiceCountryCode= "NL"
            invoice.InvoiceCurrencyCode= "EUR"
            invoice.InvoiceCustomerName= "Jan"
            invoice.InvoiceDate= "2019-03-15T15=14=48.0202329Z"
            invoice.InvoicePostalCode= "8097PB"
            invoice.IsCreditInvoice= false
            invoice.OurReference= ""
            invoice.Persons= []
            invoice.ReverseChargeOnConstructionServices= false
            invoice.RotPropertyType= null
            invoice.RotReducedInvoicingAmount= 0
            invoice.RotReducedInvoicingAutomaticDistribution= false
            invoice.RotReducedInvoicingOrgNumber= null
            invoice.RotReducedInvoicingPropertyName= null
            
            
            invoice.SalesDocumentAttachments= []
            invoice.TotalAmount= 26.62
            invoice.TotalAmountBaseCurrency= 26.62
            invoice.TotalRoundings= 0
            invoice.TotalVatAmount= 4.62
            invoice.TotalVatAmountBaseCurrency= 4.62
            invoice.YourReference= ""
            */

            let rows = [];
            let totals;
            let lineNr = 0;
            try {
                totals = WorkorderItemService.calculateTotals(orderItems);

                console.log('totals', totals);

                let defaultRow = {};
                defaultRow.IsTextRow = false //if true article id not required
                defaultRow.ArticleId = ''
                defaultRow.ArticleNumber = '' // !
                defaultRow.CostCenterItemId1 = null
                defaultRow.CostCenterItemId2 = null
                defaultRow.CostCenterItemId3 = null
                defaultRow.DiscountPercentage = 0
                defaultRow.IsWorkCost = false
                defaultRow.LineNumber = 0 // !
                defaultRow.MaterialCosts = 0
                defaultRow.ProjectId = projectID
                defaultRow.Quantity = 0
                defaultRow.ReversedConstructionServicesVatFree = false
                defaultRow.Text = ""
                defaultRow.UnitPrice = 0
                defaultRow.WorkCostType = 0
                defaultRow.WorkHours = 0

                let textRow = {};
                textRow.IsTextRow = true //if true article id not required
                textRow.CostCenterItemId1 = null
                textRow.CostCenterItemId2 = null
                textRow.CostCenterItemId3 = null
                textRow.DiscountPercentage = 0
                textRow.IsWorkCost = false
                textRow.LineNumber = 0 // !
                textRow.MaterialCosts = 0
                textRow.ProjectId = projectID
                textRow.Quantity = 0
                textRow.ReversedConstructionServicesVatFree = false
                textRow.Text = '';
                textRow.UnitPrice = 0
                textRow.WorkCostType = 0
                textRow.WorkHours = 0

                //VERRICHTE WERKZAAMHEDEN WEKEN
                let row = Object.assign({}, textRow);
                row.LineNumber = lineNr;
                lineNr++;
                row.Text = "Verrichte werkzaamheden week " + WorkorderItemService.getWeekNumbers(orderItems.filter((item) => { return item.checked })).join();
                rows.push(row)

                let article;
                let usersOrdersUser = WorkorderItemService.calculateTotalUsers(orderItems);
                for (let i = 0; i < usersOrdersUser.length; i++) {
                    let user = usersOrdersUser[i];

                    // {user.totalKilometers > 0 && <tr><td>Gemaakte kilometers {user.fullName}</td><td style={{ textAlign: 'right' }}>{user.totalKilometers}</td><td style={{ textAlign: 'right' }}>{props.settings.kmvergoeding}</td><td style={{ textAlign: 'right' }}>{(Math.round((user.totalKilometers * props.settings.kmvergoeding) * 100, 2) / 100)} </td></tr>}
                    article = articles.find((item) => { return item.Number === settings['articlekmvergoeding' + user.postFix] });
                    if (article && user.totalKilometers > 0) {
                        let row = Object.assign({}, defaultRow);
                        row.ArticleId = article.Id
                        row.ArticleNumber = settings['articlekmvergoeding' + user.postFix]
                        row.LineNumber = lineNr;
                        lineNr++
                        row.Quantity = user.totalKilometers
                        row.Text = article.Name + ' ' + user.fullName;
                        row.UnitPrice = settings['kmvergoeding' + user.postFix];
                        rows.push(row)
                    }

                    // {user.totalTravelHours > 0 && <tr><td>Gemaakte reisuren {user.fullName}</td><td style={{ textAlign: 'right' }}>{user.totalTravelHours}</td><td style={{ textAlign: 'right' }}>{props.settings.reisuren}</td><td style={{ textAlign: 'right' }}>{(Math.round((user.totalTravelHours * props.settings.reisuren) * 100, 2) / 100)} </td></tr>}
                    article = articles.find((item) => { return item.Number === settings['articlereisuren' + user.postFix] });
                    if (article && user.totalTravelHours > 0) {
                        let row = Object.assign({}, defaultRow);
                        row.ArticleId = article.Id
                        row.ArticleNumber = settings['articlereisuren' + user.postFix];
                        row.LineNumber = lineNr;
                        lineNr++;
                        row.Quantity = user.totalTravelHours;
                        row.Text = article.Name + ' ' + user.fullName;
                        row.UnitPrice = settings['reisuren' + user.postFix];
                        rows.push(row)
                    }

                    // {user.totalNights > 0 && <tr><td>Overnachting {user.fullName}</td><td style={{ textAlign: 'right' }}>{user.totalNights}</td><td style={{ textAlign: 'right' }}>{props.settings.overnachting}</td><td style={{ textAlign: 'right' }}>{(Math.round((user.totalNights * props.settings.overnachting) * 100, 2) / 100)} </td></tr>}
                    article = articles.find((item) => { return item.Number === settings['articleovernachting' + user.postFix] });
                    if (article && user.totalNights > 0) {
                        let row = Object.assign({}, defaultRow);
                        row.ArticleId = article.Id;
                        row.ArticleNumber = settings['articleovernachting' + user.postFix];
                        row.LineNumber = lineNr;
                        lineNr++;
                        row.Quantity = user.totalNights;
                        row.Text = article.Name + ' ' + user.fullName;
                        row.UnitPrice = settings['overnachting' + user.postFix]
                        rows.push(row)
                    }

                    // {user.totalWorkplace > 0 && <tr><td>Gewerkte uren werkplaats {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalWorkplace / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.uurloonwerkplaats}</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalWorkplace / 60) * props.settings.uurloonwerkplaats) * 100, 2) / 100)} </td></tr>}
                    article = articles.find((item) => { return item.Number === settings['articleuurloonwerkplaats' + user.postFix] });
                    if (article && user.totalWorkplace > 0) {
                        let row = Object.assign({}, defaultRow);
                        row.ArticleId = article.Id
                        row.ArticleNumber = settings['articleuurloonwerkplaats' + user.postFix]
                        row.LineNumber = lineNr;
                        lineNr++
                        row.Quantity = (user.totalWorkplace / 60) || 0
                        row.Text = article.Name + ' ' + user.fullName
                        row.UnitPrice = settings['uurloonwerkplaats' + user.postFix] || 0
                        rows.push(row)
                    }



                    // {user.totalOverhoursWorkplace > 0 && <tr><td>Gewerkte overuren werkplaats  {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalOverhoursWorkplace / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.overuren}%</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalOverhoursWorkplace / 60) * props.settings.uurloonwerkplaats) * props.settings.overuren, 2) / 100)} </td></tr>}
                    let overTime = (Math.round(((user.totalOverhoursWorkplace / 60) * settings['uurloonwerkplaats' + user.postFix]) * settings['overuren' + user.postFix], 2) / 100);
                    let overTimeSaterday = (Math.round(((user.totalOverhoursWorkplaceSaturday / 60) * settings['uurloonwerkplaats' + user.postFix]) * settings['overuren' + user.postFix], 2) / 100);
                    let overTimeSunday = (Math.round(((user.totalOverhoursWorkplaceSunday / 60) * settings['uurloonwerkplaats' + user.postFix]) * settings['overuren' + user.postFix], 2) / 100);

                    let overTimeLocation = (Math.round(((user.totalOverhoursLocation / 60) * settings['uurloonlocatie' + user.postFix]) * settings['overuren' + user.postFix], 2) / 100);
                    let overTimeLocationSaterday = (Math.round(((user.totalOverhoursLocationSaturday / 60) * settings['uurloonlocatie' + user.postFix]) * settings['overuren' + user.postFix], 2) / 100);
                    let overTimeLocationSunday = (Math.round(((user.totalOverhoursLocationSunday / 60) * settings['uurloonlocatie' + user.postFix]) * settings['overuren' + user.postFix], 2) / 100);

                    let totalPrice = overTime + overTimeSaterday + overTimeSunday + overTimeLocation + overTimeLocationSaterday + overTimeLocationSunday;
                    let totalMinutes = (user.totalOverhoursWorkplace + user.totalOverhoursWorkplaceSaturday + user.totalOverhoursWorkplaceSunday + user.totalOverhoursLocation + user.totalOverhoursLocationSaturday + user.totalOverhoursLocationSunday);

                    try {
                        let article = articles.find((item) => { return item.Number === settings['articleoveruren' + user.postFix] });
                        if (article && totalMinutes > 0) {
                            let row = Object.assign({}, defaultRow);
                            row.ArticleId = article.Id
                            row.ArticleNumber = settings['articleoveruren' + user.postFix]
                            row.LineNumber = lineNr;
                            lineNr++;
                            row.Quantity = (totalMinutes / 60) || 0
                            row.Text = article.Name + ' ' + user.fullName
                            row.UnitPrice = (totalPrice / (totalMinutes / 60)) || 0 //average
                            rows.push(row)
                        }
                    } catch (ex) {
                        console.log(ex)
                    }


                    // {user.totalLocation > 0 && <tr><td>Gewerkte uren montage/locatie {user.fullName}</td><td style={{ textAlign: 'right' }}>{(user.totalLocation / 60)}</td><td style={{ textAlign: 'right' }}>{props.settings.uurloonwerkplaats}</td><td style={{ textAlign: 'right' }}>{(Math.round(((user.totalLocation / 60) * props.settings.uurloonwerkplaats) * 100, 2) / 100)} </td></tr>}
                    article = articles.find((item) => { return item.Number === settings['articleuurloonlocatie' + user.postFix] });
                    if (article && user.totalLocation > 0) {
                        let row = Object.assign({}, defaultRow);
                        row.ArticleId = article.Id
                        row.ArticleNumber = settings['articleuurloonlocatie' + user.postFix]
                        row.LineNumber = lineNr;
                        lineNr++;
                        row.Quantity = (user.totalLocation / 60) || 0
                        row.Text = article.Name + ' ' + user.fullName
                        row.UnitPrice = settings['uurloonlocatie' + user.postFix] || 0
                        rows.push(row)
                    }

                    //gasgeven
                    article = articles.find((item) => { return item.Number === settings['articlegasgeven' + user.postFix] });
                    if (article && user.totalRaceMinutes > 0) {
                        let row = Object.assign({}, defaultRow);
                        row.ArticleId = article.Id
                        row.ArticleNumber = settings['articlegasgeven' + user.postFix]
                        row.LineNumber = lineNr;
                        lineNr++
                        row.Quantity = (user.totalRaceMinutes / 60) || 0
                        row.Text = article.Name + ' ' + user.fullName
                        row.UnitPrice = settings['gasgeven' + user.postFix] || 0
                        rows.push(row)
                    }
                }

                //OPMERKINGEN
                if (remarks) {
                    let row = Object.assign({}, textRow);
                    row.LineNumber = lineNr;
                    lineNr++;
                    row.Text = remarks;
                    if (row.Text.length > 1999) {
                        row.Text = row.Text.substring(0, 1998) + '...'
                    }
                    rows.push(row)
                }

                //MATERIAALKOSTEN
                if (materialCost > 0) {
                    try {
                        let article = articles.find((item) => { return item.Number === settings.articlemateriaal });
                        if (article) {
                            let row = Object.assign({}, defaultRow);
                            row.ArticleId = article.Id
                            row.ArticleNumber = settings.articlemateriaal
                            row.LineNumber = lineNr;
                            lineNr++;
                            row.Quantity = 1;
                            row.Text = article.Name;
                            row.UnitPrice = materialCost;
                            rows.push(row);
                        }
                    } catch (ex) {
                        console.log(ex)
                    }
                }

                //MATERIAAL
                if (material) {
                    let row = Object.assign({}, textRow);
                    row.LineNumber = lineNr;
                    lineNr++;
                    row.Text = material;
                    if (row.Text.length > 1999) {
                        row.Text = row.Text.substring(0, 1998) + '...'
                    }
                    rows.push(row)
                }

                //SENDING
                invoice.Rows = rows;

                console.log(invoice);
                axios.put(vismaAPI + '/customerinvoices', invoice, { headers: prepHeaders })
                    .then(res => {
                        resolve(res.data);
                    }, err => {
                        console.log('err', err);
                        reject(err);
                    })

            } catch (ex) {
                console.log(ex)
                reject(ex);
            }


            //settings.articleuurloonwerkplaats

            //settings.articlekmvergoeding
            //settings.articleovernachting
            //settings.articleoveruren
            //settings.articlereisuren

            /*
                        row.IsTextRow= false //if true article id nog required
                        row.ArticleId= "78aa1b01-f3cb-401e-ad32-89baa410a4db"
                        row.ArticleNumber= "123"
                        row.CostCenterItemId1= null
                        row.CostCenterItemId2= null
                        row.CostCenterItemId3= null
                        row.DiscountPercentage= 0
                       
                        row.IsWorkCost= false
                        row.LineNumber= 0
                        row.MaterialCosts= 0
                        row.ProjectId= projectID
                        row.Quantity= 1
                        row.ReversedConstructionServicesVatFree= false
                        row.Text= "Uren werkplaats"
                        row.UnitAbbreviation= "u"
                        row.UnitName= "Uur"
                        row.UnitPrice= 22
                     //   row.VatRateId= "7813e04f-14a1-4edf-964e-9960e00912fe"
                        row.WorkCostType= 0
                        row.WorkHours= 0
            
                        rows.push(row)
            
            */

        });
    }
}
export default Visma;